import { SVGProps } from 'react'

const LoadingV2 = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path d='M12 2V6' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M12 18V22' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M22 12H18' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M6 12H2' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path
                d='M4.92871 4.92896L7.75713 7.75738'
                stroke='white'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.2432 16.2427L19.0716 19.0711'
                stroke='white'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M19.0706 4.92896L16.2422 7.75738'
                stroke='white'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.75713 16.2427L4.92871 19.0711'
                stroke='white'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default LoadingV2
